import { render, staticRenderFns } from "./PopupAddSection.vue?vue&type=template&id=abed35be&"
import script from "./PopupAddSection.vue?vue&type=script&lang=js&"
export * from "./PopupAddSection.vue?vue&type=script&lang=js&"
import style0 from "./PopupAddSection.vue?vue&type=style&index=0&id=abed35be&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports